import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar, Footer } from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Lunch from './pages/Lunch';
import Culture from './pages/Culture';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menukort" element={<Menu />} />
          <Route path="/frokostordning" element={<Lunch />} />
          <Route path="/madkultur" element={<Culture />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
